type Props = {
  circleColor: string;
};

const WDTickerBackground: FC<Props> = ({ circleColor }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="379"
    height="96"
    viewBox="0 0 379 96"
    fill="none"
  >
    <circle
      cx="365.273"
      cy="34.6683"
      r="7.70833"
      transform="rotate(-75.0324 365.273 34.6683)"
      fill={circleColor}
    />
    <circle
      cx="341.164"
      cy="-0.50178"
      r="3.08333"
      transform="rotate(-75.0324 341.164 -0.50178)"
      fill={circleColor}
    />
    <circle
      cx="304.814"
      cy="4.14276"
      r="1.54167"
      transform="rotate(-75.0324 304.814 4.14276)"
      fill={circleColor}
    />
    <circle
      cx="264.939"
      cy="87.6352"
      r="9.25"
      transform="rotate(-75.0324 264.939 87.6352)"
      fill={circleColor}
    />
    <circle
      cx="3.08333"
      cy="3.08333"
      r="3.08333"
      transform="matrix(-0.258272 -0.966072 -0.966072 0.258272 190.273 21.0638)"
      fill={circleColor}
    />
    <circle
      cx="9.25"
      cy="9.25"
      r="9.25"
      transform="matrix(-0.258272 -0.966072 -0.966072 0.258272 178.048 5.18231)"
      fill={circleColor}
    />
    <circle
      cx="15.4102"
      cy="49.2674"
      r="7.70833"
      transform="rotate(104.968 15.4102 49.2674)"
      fill={circleColor}
    />
    <circle
      cx="39.5197"
      cy="84.4375"
      r="3.08333"
      transform="rotate(104.968 39.5197 84.4375)"
      fill={circleColor}
    />
    <circle
      cx="75.8692"
      cy="79.793"
      r="1.54167"
      transform="rotate(104.968 75.8692 79.793)"
      fill={circleColor}
    />
  </svg>
);

export default WDTickerBackground;
